import examActions from "../Redux/exam/actions";
import { getClientInfo } from "./clientInfo";

export function auditLog({ data, dispatch, heartBeat, debugInfo }) {
  const logData = {
    srNo: data?.srNo,
    auditLog: [
      {
        ...data,
        ...(debugInfo ? { debugInfo: getClientInfo(debugInfo) } : {}),
        // Timestamp: heartBeat?.data,
      },
    ],
  };  
  dispatch({ type: examActions.AUDIT_LOG, payload: { data: logData } });
}
